import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ GET COMPANY TAXONOMY BINDING
 * The single active taxonomy (Ref.ESG_TaxonomyHeader.HeaderId) a company is
 * connected to, or null if none set yet.
 * Targets: CompanyTaxonomyController.get (Corp.usp_Z_08_CompanyTaxonomy_Get)
 */
export const fetchCompanyTaxonomy = async (corporateEntityId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/company-taxonomy/get",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId })
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : null;
    } catch (err) {
        console.error("Company Taxonomy Fetch Failed:", err);
        return null;
    }
};

/**
 * 🛰️ SET COMPANY TAXONOMY BINDING
 * Always supersedes any prior active binding — one taxonomy per company.
 * Targets: CompanyTaxonomyController.set (Corp.usp_Z_08_CompanyTaxonomy_Set)
 */
export const setCompanyTaxonomy = async (corporateEntityId, { headerId, isBespoke, sourceEntryPointUrl }, config) => {
    try {
        const payload = {
            CorporateEntityId: corporateEntityId,
            HeaderId: headerId,
            IsBespoke: !!isBespoke,
            SourceEntryPointUrl: sourceEntryPointUrl || null,
        };

        const rawData = await dbPayload(
            "/api/v1/sustina/company-taxonomy/set",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Company taxonomy binding failed.");
        return res.data;
    } catch (err) {
        console.error("Company Taxonomy Set Error:", err);
        throw err;
    }
};

/**
 * 🛰️ CLEAR COMPANY TAXONOMY BINDING
 * Targets: CompanyTaxonomyController.clear (Corp.usp_Z_08_CompanyTaxonomy_Clear)
 */
export const clearCompanyTaxonomy = async (corporateEntityId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/company-taxonomy/clear",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId })
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Company taxonomy clear failed.");
        return true;
    } catch (err) {
        console.error("Company Taxonomy Clear Error:", err);
        throw err;
    }
};
